import Modal from 'components/Modal';
import React, { useState } from 'react'
import removeImg from '../../../../static/images/remove.png';
import downloadImg from '../../../../static/images/download.png';
import Slider from './carouselImage/Slider';
import { FORMAT_DATE, FORMAT_DATE_TIME } from '../mle.constants';
import moment from 'moment';
import { convertTimeStampToFormattedDate } from '../mle.utils';
import { isValidTimestamp } from 'utils/helperMethods';

const ViewDocument = ({
    document
}) => {
    console.log("view document ", document);
    if (!document) {
        return <></>;
    }
    return <Slider sliderImages={document} />
}

const MultiImageViewModal = ({
    multiDocuments = [],
    setMultiDocuments,
    handleDeleteFile,
    documentDetails = [],
    defaultDate = null
}) => {
    const [activeIndex, setActiveIndex] = useState(0);
    const documentDetail = documentDetails?.find((details) => details?.index === activeIndex);
    const hasDocumentDetails = documentDetails?.length > 0;
    const hasTimestamp = documentDetail?.timeStamp;
    return (
        <Modal
            modalIsOpen={multiDocuments?.length}
            shouldCloseOnOverlayClick
            shouldCloseOnEsc
            closeModal={() => setMultiDocuments(null)}
            customWrapperClass="content-modal modal-xl"
        >
            <div className="modal-header">
                <h2 className="modal-heading">
                    {
                        (!hasDocumentDetails || !documentDetail || !hasTimestamp) ? (
                            <span>Document View</span>
                        ) : (
                            <>
                                <span className='title'>
                                    Uploaded on&nbsp;
                                </span>
                                <span className='time-stamp'>
                                {convertTimeStampToFormattedDate(
                                    isValidTimestamp(documentDetail.timeStamp)
                                        ? documentDetail.timeStamp
                                        : defaultDate
                                )}
                                </span>
                            </>
                        )
                    }
                </h2>
                <img
                    src={removeImg}
                    alt="Close"
                    onClick={() => {
                        setMultiDocuments(null)
                    }}
                />
            </div>
            <div className="modal-body">
            <div id="carouselExampleControls" className="carousel slide" data-ride="carousel">
                    {multiDocuments?.length > 0 &&
                        <Slider 
                            sliderImages={multiDocuments} 
                            handleDeleteFile={handleDeleteFile}
                            activeIndex={activeIndex}
                            setActiveIndex={setActiveIndex}
                        />
                    }
                </div>
            </div>
        </Modal>
    );
}

export default MultiImageViewModal
